class ProductModal extends ModalDialog {
  constructor() {
    super();

    this.currentIndex = 0;
    this.slider = this.querySelector('[data-modal-slider]');
    this.wrapper = this.slider?.querySelector('.swiper-wrapper');
    this.slides = [];

    this.initSlider();
  }

  initSlider() {
    if (!this.slider || !this.wrapper) return;

    this.slides = Array.from(this.wrapper.children);

    this.slider.style.overflow = 'hidden';

    this.wrapper.style.display = 'flex';
    this.wrapper.style.transition = 'transform 0.4s ease';
    this.wrapper.style.willChange = 'transform';

    this.slides.forEach(slide => {
      slide.style.flex = '0 0 100%';
    });

    this.setupNavigation();
    this.goToSlide(0, false);
  }

  setupNavigation() {
    const prevBtn = this.querySelector('.swiper-button--prev');
    const nextBtn = this.querySelector('.swiper-button--next');

    if (prevBtn) {
      prevBtn.onclick = () => this.prevSlide();
    }

    if (nextBtn) {
      nextBtn.onclick = () => this.nextSlide();
    }
  }

  updateSlider() {
    if (!this.wrapper) return;

    this.slides = Array.from(this.wrapper.children).filter(slide => {
      return !slide.classList.contains('hidden');
    });

    this.slides.forEach(slide => {
      slide.style.flex = '0 0 100%';
    });

    this.goToSlide(0, false);
  }

  goToSlide(index, animate = true) {
    if (!this.slides.length) return;

    this.currentIndex = Math.max(
      0,
      Math.min(index, this.slides.length - 1)
    );

    this.wrapper.style.transition = animate
      ? 'transform 0.4s ease'
      : 'none';

    const activeSlide = this.slides[this.currentIndex];

    const offset = activeSlide.offsetLeft;

    this.wrapper.style.transform = `translateX(-${offset}px)`;

    this.wrapper.querySelectorAll('.swiper-slide-active').forEach(slide => {
      slide.classList.remove('swiper-slide-active');
    });

    activeSlide.classList.add('swiper-slide-active');

    requestAnimationFrame(() => {
      this.wrapper.style.transition = 'transform 0.4s ease';
    });

    this.playActiveSlideVideo();
  }

  nextSlide() {
    const nextIndex =
      this.currentIndex >= this.slides.length - 1
        ? 0
        : this.currentIndex + 1;

    this.goToSlide(nextIndex);
  }

  prevSlide() {
    const prevIndex =
      this.currentIndex <= 0
        ? this.slides.length - 1
        : this.currentIndex - 1;

    this.goToSlide(prevIndex);
  }

  show(opener) {
    this.openedBy = opener;
    this.setAttribute('open', '');
    trapFocus(this, this.dialogHolder);
    window.pauseAllMedia();

    if (opener.hasAttribute('data-model-opener')) {
      this.showActiveMedia(opener.dataset.mediaId);
      return;
    }

    this.showActiveMedia();
  }

  connectedCallback() {
    document.addEventListener('click', event => {
      if (
        !this.openedBy ||
        (!this.contains(event.target) &&
          !this.openedBy.contains(event.target))
      ) {
        this.hide();
      }
    });
  }

  showActiveMedia(activeMedia = 'videos') {
    if (activeMedia !== 'videos') {
      const activeMediaId = this.openedBy.getAttribute('data-media-id');

      const activeMedia = this.querySelector(
        `[data-media-id="${activeMediaId}"]`
      );

      activeMedia?.loadContent();

      activeMedia.parentElement.classList.add('swiper-slide');
      activeMedia.parentElement.classList.remove('hidden');

      this.querySelectorAll('[data-media-id]').forEach(media => {
        if (media === activeMedia) return;

        media.parentElement.classList.remove('swiper-slide');
        media.parentElement.classList.add('hidden');
      });

      this.updateSlider();
      return;
    }

    const modalMedia = this.querySelectorAll('[data-media-id]');

    modalMedia.forEach(media => {
      if (media.tagName.toLowerCase() === 'product-model') {
        media.parentElement.classList.remove('swiper-slide');
        media.parentElement.classList.add('hidden');
        return;
      }

      media.parentElement.classList.add('swiper-slide');
      media.parentElement.classList.remove('hidden');
    });

    this.querySelector(
      '[data-media-id]:not(.hidden [data-media-id])'
    )?.loadContent();

    this.updateSlider();
  }

  hide() {
    super.hide();
    pauseAllMedia();

    const activeModel = this.querySelector(
      '.swiper-slide-active product-model'
    );

    if (!activeModel) return;

    activeModel.removeAttribute('loaded');
    activeModel.querySelector('.shopify-model-viewer-ui')?.remove();
  }

  playActiveSlideVideo() {
    pauseAllMedia();

    const activeSlide = this.slides[this.currentIndex];

    if (!activeSlide) return;

    activeSlide.querySelector('deferred-media')?.loadContent();
  }
}

customElements.define('product-modal', ProductModal);